export default __webpack_public_path__ + "static/four_body_v2-0913b443c6f5fe08dbd653fa2ab1421d.png";